<app-navbar-style-two></app-navbar-style-two>

<div class="home-page">

    <!-- ================= SLIDER ================= -->
    <section id="section-slider" class="slider-section">

        <div id="mainSlider" class="carousel slide" data-bs-ride="carousel" [attr.data-bs-interval]="autoplaySpeed"
            data-aos="fade-in">

            <div class="carousel-indicators">
                <button *ngFor="let img of sliderImages; let i = index" type="button" data-bs-target="#mainSlider"
                    [attr.data-bs-slide-to]="i" [class.active]="i === 0"></button>
            </div>

            <div class="carousel-inner">
                <div *ngFor="let img of sliderImages; let i = index" class="carousel-item" [class.active]="i === 0">
                    <img [src]="img" loading="lazy" class="d-block w-100 slider-img" alt="slide">
                </div>
            </div>

            <button class="carousel-control-prev" type="button" data-bs-target="#mainSlider" data-bs-slide="prev">
                <span class="carousel-control-prev-icon"></span>
            </button>

            <button class="carousel-control-next" type="button" data-bs-target="#mainSlider" data-bs-slide="next">
                <span class="carousel-control-next-icon"></span>
            </button>

        </div>

    </section>

    <!-- ================= LEGACY SECTION ================= -->
    <section id="section-legacy" class="al_row al_Section section-legacy p-0">
        <div class="container-fluid p-0">
            <div class="row align-items-center g-0">

                <div class="col-md-6 fade-right" data-aos="fade-right">
                    <div class="imgWrap">
                        <img src="assets/img/home-one/child-shopping.jpg" loading="lazy" class="img-fluid w-100">
                    </div>
                </div>

                <div class="col-md-6 p-3 p-md-5" data-aos="fade-left text-white">
                    <h1 class="text-white mt-5">Unikai — A Legacy of Quality for Over 50 Years</h1>
                    <p class="legacy-quote text-white"><span class="quote"><img src="assets/img/icons/quote-d.svg"
                                width="50"></span>
                        For more than five decades, Unikai has nourished families in the UAE and Oman with products they
                        trust. Today, our commitment to superior quality, purity, and taste extends to households
                        worldwide, continuing a legacy of excellence that generations rely on and cherish.<span
                            class="quote"><img src="assets/img/icons/quote-l.svg" width="50"></span>
                    </p>
                </div>

            </div>
        </div>
    </section>

    <!-- ================= PRODUCTS SECTION ================= -->
    <section id="section-products" class="section products-section text-center">
        <div class="container-fluid p-0" data-aos="zoom-in">

            <h2 class="highlight mb-0">Our Products Range</h2>
            <h2 class="heading mb-2">Proud to be part of your life</h2>

            <img src="assets/img/home-one/food-about.png" loading="lazy" class="img-fluid w-100">

            <button class="btn btn-primary mt-2 mt-md-5 px-3 py-2 px-md-5 py-md-3">Explore more</button>

        </div>
    </section>

    <!-- ================= BRANDS SECTION ================= -->
    <section id="section-brands" class="section brands-section text-center p-2 p-md-5">
        <div class="container-fluid p-0">

            <h2 class="highlight mb-2">Our Brands</h2>
            <h2 class="heading mb-5">Brands Shaped by Trust</h2>


            <div class="row g-5 justify-content-center " data-aos="fade-up">
                <div class="col-3 col-md-2" *ngFor="let b of [7,3,4,5,6,1,8,9,10,11,12,13,14,15,16]">
                    <img src="assets/img/brands/brand{{b}}.png" loading="lazy" class="img-fluid brand-logo">
                </div>
            </div>

        </div>
    </section>

    <!-- ================= RECIPES SECTION ================= -->
    <section id="section-recipes" class="al_row al_Section recipes-section text-center text-white">
        <div class="container">
            <h2 class="highlight mb-4 text-white">Recipes</h2>
            <h2 class="heading mb-4">Quick Dishes Made Easy.</h2>

            <div class="row my-4 g-4 justify-content-center">
                <div class="col-md-3" *ngFor="let recipe of recipes" data-aos="fade-up">

                    <div class="recipe-card-wrapper">

                        <!-- Image -->
                        <div class="recipe-img">
                            <img [src]="recipe.image" [alt]="recipe.title" loading="lazy" />
                        </div>

                        <!-- Card -->
                        <div class="recipe-card">
                            <h5 class="mb-2">{{ recipe.title }}</h5>

                            <p>
                                {{ recipe.description }}
                            </p>

                            <a class="btn btn-recipe mt-3" [routerLink]="recipe.url">
                                Get recipe
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <button class="btn btn-warning mt-5">See more</button>
        </div>
    </section>

    <!-- ================= HIGHLIGHT SECTION ================= -->

    <section class="section-highlight" id="section-highlight">
        <div class="unikai-highlight-box">

            <div class="row text-center g-4 m-0 px-2 py-0 px-md-5 py-md-2">

                <!-- ITEM 1 -->
                <div class="col-6 col-md-3">
                    <div class="highlight-item">
                        <img src="/assets/img/icons/icons-02.svg" height="100">
                        <h5>Manufacturing</h5>
                        <p>
                            Delivering excellence across categories, Unikai is UAE’s only
                            integrated manufacturing brand producing Juice, Ice cream,
                            Dairy, and foods within a single, unified operation.
                        </p>
                    </div>
                </div>

                <!-- ITEM 2 -->
                <div class="col-6 col-md-3">
                    <div class="highlight-item">
                        <img src="/assets/img/icons/icons-03.svg" height="100">
                        <h5>Distribution</h5>
                        <p>
                            Managing distribution internally, Unikai nurtures one-on-one
                            relationships with B2B, HORECA, and partner customers.
                        </p>
                    </div>
                </div>

                <!-- ITEM 3 -->
                <div class="col-6 col-md-3">
                    <div class="highlight-item">
                        <img src="/assets/img/icons/icons-04.svg" height="100">
                        <h5>Innovation & Quality</h5>
                        <p>
                            Innovation tailored for every audience, backed by stringent
                            quality checks completed entirely within Unikai’s facilities.
                        </p>
                    </div>
                </div>

                <!-- ITEM 4 -->
                <div class="col-6 col-md-3">
                    <div class="highlight-item">
                        <img src="/assets/img/icons/icons-01.svg" height="100">
                        <h5>Happy Customers</h5>
                        <p>
                            From end consumers to retail partners, Unikai has built decades
                            of loyalty, memories, and happy connections that define our brand.
                        </p>
                    </div>
                </div>

            </div>

            <!-- CTA -->
            <div class="text-center">
                <a href="#" class="btn btn-corporate">Visit Corporate Profile</a>
            </div>

        </div>
    </section>



</div>

<!-- ================= DOT NAVIGATION ================= -->
<nav class="dot-nav">
    <span *ngFor="let sec of sections" class="dot" [style.background]="sec.color" (click)="scrollTo(sec.id)"></span>
</nav>

<app-footer-style-one></app-footer-style-one>
<!-- ================= FOOTER ================= -->